import React from "react";
import HomePage from "../container/Dashboard/Dashboard";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../container/Login/Login";
import SetPassword from "../container/Login/SetPassword";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "../component/ProtectedRoute";
import PublicRoute from "../component/PublicRoute";

const AuthenticatesRoutes = () => {
  return (
    <>
      <Routes>
        {/* Public Routes - Only accessible when NOT authenticated */}
        <Route 
          path="/login" 
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } 
        />
        <Route 
          path="/set-password/:token" 
          element={
            <PublicRoute>
              <SetPassword />
            </PublicRoute>
          } 
        />
        
        {/* Private Routes - Only accessible when authenticated */}
        <Route 
          path="/dashboard/*" 
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          } 
        />
        
        {/* Default redirect */}
        <Route path="/*" element={<Navigate to="/login" />} />
      </Routes>
      
    
    </>
  );
};

export default AuthenticatesRoutes;